module.exports = __webpack_public_path__ + "static/sun-7167df7cf28f8e1afa4cf543dff0def4.png";